<template>
  <a-drawer
    :destroy-on-close="true"
    :title="isUpdate ? '服务编辑' : '服务创建'"
    :visible="visible"
    :width="800"
    @close="closeDrawer"
  >
    <a-form-model
      ref="form"
      :label-col="{
        span: 4,
        style: {
          textAlign: 'left'
        }
      }"
      :model="form"
      :rules="rules"
      :wrapper-col="{
        span: 20
      }"
    >
      <a-form-model-item label="云服务器" prop="host">
        <simple-select
          v-model="form.host"
          :options="hostOptions"
          :autoSelect="false"
          style="width: 100%"
        ></simple-select>
      </a-form-model-item>
      <a-form-model-item label="服务类型" prop="softwareType">
        <a-input v-model="form.softwareType" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="服务名称" prop="name">
        <a-input v-model="form.name" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="服务端口" prop="port">
        <a-input v-model="form.port" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="服务端口协议" prop="protocol">
        <a-input v-model="form.protocol" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="对应版本" prop="version">
        <a-input v-model="form.version" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="是否国产" prop="domestic">
        <a-radio-group name="domesticGroup" v-model="form.domestic">
          <a-radio :value="true">是</a-radio>
          <a-radio :value="false">否</a-radio>
        </a-radio-group>
      </a-form-model-item>
      <a-form-model-item label="服务管理员" prop="manager">
        <a-input v-model="form.manager" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="管理员联系方式" prop="managerPhone">
        <a-input v-model="form.managerPhone" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="到期提醒类型" prop="expireType">
        <a-input v-model="form.expireType" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="到期时间" prop="expiresAt">
        <a-date-picker v-model="form.expiresAt" style="width: 100%"></a-date-picker>
      </a-form-model-item>
      <a-form-model-item label="服务地址" prop="address">
        <a-input v-model="form.address" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item label="备注" prop="comment">
        <a-input v-model="form.comment" :max-length="128"></a-input>
      </a-form-model-item>
      <a-form-model-item
        :wrapper-col="{ span: 20, offset: 4 }"
        style="margin-bottom: 0"
      >
        <a-space size="middle">
          <a-button :loading="loading" type="primary" @click="ok">
            确定
          </a-button>
          <a-button @click="closeDrawer">取消</a-button>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </a-drawer>
</template>

<script>
import moment from 'moment'
import {
  getSoftwareInventory,
  updateSoftwareInventory,
  createSoftwareInventory,
  getHostInventoryList
} from '@/api/inventory.js'
import SimpleSelect from '@/components/select/SimpleSelect.vue'

export default {
  name: 'InputDrawer',
  components: {
    SimpleSelect
  },
  data () {
    return {
      visible: false,
      isUpdate: false,
      form: {
        id: '',
        host: undefined,
        softwareType: '',
        name: '',
        port: '',
        protocol: '',
        version: '',
        domestic: false,
        manager: '',
        managerPhone: '',
        expireType: '',
        expiresAt: undefined,
        address: '',
        comment: ''
      },
      rules: {
        name: [
          {
            message: '请输入服务名称',
            required: true,
            trigger: 'blur'
          }
        ],
        host: [
          {
            message: '请选择云服务器',
            required: true,
            trigger: 'select'
          }
        ]
      },
      loading: false,
      hostOptions: []
    }
  },
  methods: {
    show (id) {
      this.fetchHostList()
      if (id) {
        this.isUpdate = true
        getSoftwareInventory(id)
          .then(res => {
            const data = res.data
            this.form = {
              id: data.id,
              host: data.host ? { label: data.host.name, value: data.host.id } : undefined,
              softwareType: data.software_type,
              name: data.name,
              port: data.port,
              protocol: data.protocol,
              version: data.version,
              domestic: data.domestic,
              manager: data.manager,
              managerPhone: data.manager_phone,
              expireType: data.expire_type,
              expiresAt: data.expires_at ? moment(data.expires_at, 'YYYY-MM-DD') : undefined,
              address: data.address,
              comment: data.comment
            }
          })
          .finally(() => {
            this.visible = true
          })
      } else {
        this.isUpdate = false
        this.visible = true
      }
    },
    closeDrawer () {
      this.form = {
        id: '',
        host: undefined,
        softwareType: '',
        name: '',
        port: '',
        protocol: '',
        version: '',
        domestic: false,
        manager: '',
        managerPhone: '',
        expireType: '',
        expiresAt: undefined,
        address: '',
        comment: ''
      }
      this.hostOptions = []
      this.isUpdate = false
      this.$refs.form.resetFields()
      this.visible = false
    },
    ok () {
      this.$refs.form.validate(valid => {
        if (valid) {
          this.loading = true
          const params = {
            name: this.form.name,
            host_id: this.form.host.value,
            domestic: this.form.domestic
          }
          if (this.form.softwareType) params.software_type = this.form.softwareType
          if (this.form.name) params.name = this.form.name
          if (this.form.port) params.port = this.form.port
          if (this.form.protocol) params.protocol = this.form.protocol
          if (this.form.version) params.version = this.form.version
          if (this.form.manager) params.manager = this.form.manager
          if (this.form.managerPhone) params.manager_phone = this.form.managerPhone
          if (this.form.expireType) params.expire_type = this.form.expireType
          if (this.form.address) params.address = this.form.address
          if (this.form.expiresAt) params.expires_at = this.form.expiresAt.format('YYYY-MM-DD')
          if (this.form.comment) params.comment = this.form.comment

          if (this.isUpdate) {
            updateSoftwareInventory(this.form.id, params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          } else {
            createSoftwareInventory(params)
              .then(res => {
                this.$message.success(res.message)
                this.$emit('ok')
                this.closeDrawer()
              })
              .finally(() => {
                this.loading = false
              })
          }
        }
      })
    },
    fetchHostList () {
      getHostInventoryList().then(res => {
        if (res.data && res.data.total) {
          this.hostOptions = res.data.data.map(item => {
            return {
              label: item.private_ip,
              value: item.id
            }
          })
        }
      })
    }
  }
}
</script>
